import * as React from "react";
import { FormikProps } from "formik";
import { FormValues } from "../../support/FormValues";
import bootstrapStyles from "../../css/bootstrap.module.css";
import ReviewData from "../../components/Review/ReviewData";
import ReviewHeader from "../../components/Review/ReviewHeader";

interface ReviewProps {
  formikBag: FormikProps<FormValues>;
}

const ReviewPersonalInformation = ({ formikBag: { values } }: ReviewProps) => {
  return (
    <div className="reviewPersonalInformation-wrapper">
      <ReviewHeader
        label="Personal Information"
        navigation="/personalInformation"
      />

      <div className={bootstrapStyles.row}>
        <ReviewData
          id="fullName"
          reviewLabel="Name"
          reviewData={`${values.firstName} ${values.lastName}`}
        />
        <ReviewData id="email" reviewLabel="Email" reviewData={values.email} />
      </div>

      <div className={bootstrapStyles.row}>
        <ReviewData
          id="ssn"
          reviewLabel="SSN"
          reviewData={`***-**-${values.ssn.substr(7)}`}
        />
        <ReviewData
          id="primaryPhone"
          reviewLabel="Primary Phone Number"
          reviewData={values.primaryPhone}
        />
      </div>

      <div className={bootstrapStyles.row}>
        <ReviewData
          id="birthDate"
          reviewLabel="Date of Birth"
          reviewData={values.birthDate}
        />
        <ReviewData
          id="secondaryPhone"
          reviewLabel="Secondary Phone Number"
          reviewData={values.secondaryPhone}
        />
      </div>
    </div>
  );
};

export default ReviewPersonalInformation;
